<div class="combobox" [class.combobox--open]="open()" [class.combobox--invalid]="invalid()">
  <label class="combobox__label" [attr.for]="inputId()">
    {{ label() }}
    @if (required()) {
      <span class="combobox__required" aria-hidden="true">*</span>
    }
  </label>

  <div class="combobox__control">
    <input
      class="combobox__input"
      type="text"
      role="combobox"
      autocomplete="off"
      [id]="inputId()"
      [value]="query()"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      [attr.aria-expanded]="open()"
      [attr.aria-controls]="listId()"
      [attr.aria-activedescendant]="activeDescendantId()"
      [attr.aria-autocomplete]="'list'"
      [attr.aria-required]="required() ? 'true' : null"
      [attr.aria-invalid]="invalid() ? 'true' : null"
      [attr.aria-describedby]="describedBy()"
      (input)="handleInput($event)"
      (focus)="handleFocus()"
      (blur)="handleBlur()"
      (keydown)="handleKeydown($event)" />
    <i class="bx bx-chevron-down combobox__chevron" aria-hidden="true"></i>
  </div>

  @if (open()) {
    <ul class="combobox__listbox" role="listbox" [id]="listId()" [attr.aria-label]="label()">
      @for (option of filteredOptions(); track option.value; let i = $index) {
        <li
          class="combobox__option"
          role="option"
          [id]="optionId(i)"
          [class.combobox__option--active]="i === activeIndex()"
          [class.combobox__option--selected]="isSelected(option)"
          [class.combobox__option--disabled]="option.disabled"
          [attr.aria-selected]="isSelected(option)"
          [attr.aria-disabled]="option.disabled ? 'true' : null"
          (mousedown)="selectOption(option)">
          {{ option.label }}
        </li>
      } @empty {
        <li class="combobox__option combobox__option--empty" role="option" [attr.aria-disabled]="'true'" aria-selected="false">
          No matches
        </li>
      }
    </ul>
  }

  @if (hint() && !error()) {
    <p class="combobox__hint" [id]="hintId()">{{ hint() }}</p>
  }
  @if (error()) {
    <p class="combobox__error" role="alert" [id]="errorId()">{{ error() }}</p>
  }
</div>
